/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseOpenplcApi } from '../../base-api';
export type OpenPlcEditSessionFragment = { __typename: 'EditSessionType', sessionId: string, state: Types.EditSessionState, expiresAt: any, isLive: boolean };

export type OpenPlcStagedChangeFragment = { __typename: 'StagedChangeType', sessionId: string, revision: number, savedAt: any, fileSize: number, fileName?: string, warnings: Array<string> };

export type OpenPlcProjectStatusFragment = { __typename: 'ProjectStatusType', projectId: string, locked: boolean, session?: { __typename: 'EditSessionType', sessionId: string, state: Types.EditSessionState, expiresAt: any, isLive: boolean }, stagedChange?: { __typename: 'StagedChangeType', sessionId: string, revision: number, savedAt: any, fileSize: number, fileName?: string, warnings: Array<string> } };

export type OpenPlcOrchestratorFragment = { __typename: 'OrchestratorType', orchestratorId: string, name: string, status?: string, agentVersion?: string, createdAt?: any, registeredByUserId?: string };

export type OpenPlcVplcFragment = { __typename: 'VplcType', vplcId?: string, orchestratorId: string, name: string, autonomyId?: string, recordState: Types.VplcRecordState, runtimeVersion?: string, provisioningState?: Types.ProvisioningState, provisioningDetail?: string, lastSeenBuildingAt?: any, isRunning?: boolean, healthStatus?: Types.HealthStatus, containerStatus?: Types.ContainerStatus, ipAddress?: string, createdByUserId?: string };

export type OpenPlcVplcCreateOptionsFragment = { __typename: 'VplcCreateOptionsType', internetReachable: boolean, runtimeVersions: Array<{ __typename: 'RuntimeVersionType', version: string, downloaded: boolean, prerelease: boolean }>, hostInterfaces: Array<{ __typename: 'HostInterfaceType', name: string, ipAddress?: string, subnet?: string, gateway?: string }> };

export type OpenEditSessionMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OpenEditSessionMutation = { __typename: 'Mutation', openEditSession: { __typename: 'OpenEditSessionType', sessionId: string, launchUrl: string, expiresAt: any, openedFrom: Types.SessionSource, warnings: Array<string> } };

export type EndEditSessionMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
}>;


export type EndEditSessionMutation = { __typename: 'Mutation', endEditSession: { __typename: 'EditSessionType', sessionId: string, state: Types.EditSessionState, expiresAt: any, isLive: boolean } };

export type AcceptStagedChangeMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  commitMessage?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AcceptStagedChangeMutation = { __typename: 'Mutation', acceptStagedChange: { __typename: 'AcceptStagedChangeType', versionId: string } };

export type DiscardStagedChangeMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
}>;


export type DiscardStagedChangeMutation = { __typename: 'Mutation', discardStagedChange: { __typename: 'StagedChangeType', sessionId: string, revision: number, savedAt: any, fileSize: number, fileName?: string, warnings: Array<string> } };

export type RegisterOrchestratorMutationVariables = Types.Exact<{
  orchestratorId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type RegisterOrchestratorMutation = { __typename: 'Mutation', createOrchestrator: { __typename: 'OrchestratorType', orchestratorId: string, name: string, status?: string, agentVersion?: string, createdAt?: any, registeredByUserId?: string } };

export type RenameOrchestratorMutationVariables = Types.Exact<{
  orchestratorId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type RenameOrchestratorMutation = { __typename: 'Mutation', renameOrchestrator: { __typename: 'OrchestratorType', orchestratorId: string, name: string, status?: string, agentVersion?: string, createdAt?: any, registeredByUserId?: string } };

export type OrchestratorCommandMutationVariables = Types.Exact<{
  orchestratorId: Types.Scalars['String']['input'];
  command: Types.LifecycleCommand;
}>;


export type OrchestratorCommandMutation = { __typename: 'Mutation', orchestratorCommand: { __typename: 'OrchestratorCommandType', orchestratorId: string, command: Types.LifecycleCommand } };

export type DeleteOrchestratorMutationVariables = Types.Exact<{
  orchestratorId: Types.Scalars['String']['input'];
}>;


export type DeleteOrchestratorMutation = { __typename: 'Mutation', deleteOrchestrator: { __typename: 'OrchestratorDeletedType', orchestratorId: string, deletedVplcIds: Array<string> } };

export type CreateVplcMutationVariables = Types.Exact<{
  input: Types.CreateVplcInput;
}>;


export type CreateVplcMutation = { __typename: 'Mutation', createVplc: { __typename: 'VplcType', vplcId?: string, orchestratorId: string, name: string, autonomyId?: string, recordState: Types.VplcRecordState, runtimeVersion?: string, provisioningState?: Types.ProvisioningState, provisioningDetail?: string, lastSeenBuildingAt?: any, isRunning?: boolean, healthStatus?: Types.HealthStatus, containerStatus?: Types.ContainerStatus, ipAddress?: string, createdByUserId?: string } };

export type RenameVplcMutationVariables = Types.Exact<{
  vplcId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type RenameVplcMutation = { __typename: 'Mutation', renameVplc: { __typename: 'VplcType', vplcId?: string, orchestratorId: string, name: string, autonomyId?: string, recordState: Types.VplcRecordState, runtimeVersion?: string, provisioningState?: Types.ProvisioningState, provisioningDetail?: string, lastSeenBuildingAt?: any, isRunning?: boolean, healthStatus?: Types.HealthStatus, containerStatus?: Types.ContainerStatus, ipAddress?: string, createdByUserId?: string } };

export type VplcCommandMutationVariables = Types.Exact<{
  vplcId: Types.Scalars['String']['input'];
  command: Types.LifecycleCommand;
}>;


export type VplcCommandMutation = { __typename: 'Mutation', vplcCommand: { __typename: 'VplcCommandType', vplcId: string, command: Types.LifecycleCommand } };

export type DeleteVplcMutationVariables = Types.Exact<{
  vplcId: Types.Scalars['String']['input'];
}>;


export type DeleteVplcMutation = { __typename: 'Mutation', deleteVplc: { __typename: 'VplcDeletedType', vplcId: string } };

export type ReadOpenPlcProjectStatusQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
}>;


export type ReadOpenPlcProjectStatusQuery = { __typename: 'Query', projectStatus: { __typename: 'ProjectStatusType', projectId: string, locked: boolean, session?: { __typename: 'EditSessionType', sessionId: string, state: Types.EditSessionState, expiresAt: any, isLive: boolean }, stagedChange?: { __typename: 'StagedChangeType', sessionId: string, revision: number, savedAt: any, fileSize: number, fileName?: string, warnings: Array<string> } } };

export type ReadOrchestratorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadOrchestratorsQuery = { __typename: 'Query', orchestrators: Array<{ __typename: 'OrchestratorType', orchestratorId: string, name: string, status?: string, agentVersion?: string, createdAt?: any, registeredByUserId?: string }> };

export type ReadVplcsQueryVariables = Types.Exact<{
  orchestratorId: Types.Scalars['String']['input'];
}>;


export type ReadVplcsQuery = { __typename: 'Query', vplcs: Array<{ __typename: 'VplcType', vplcId?: string, orchestratorId: string, name: string, autonomyId?: string, recordState: Types.VplcRecordState, runtimeVersion?: string, provisioningState?: Types.ProvisioningState, provisioningDetail?: string, lastSeenBuildingAt?: any, isRunning?: boolean, healthStatus?: Types.HealthStatus, containerStatus?: Types.ContainerStatus, ipAddress?: string, createdByUserId?: string }> };

export type ReadVplcCreateOptionsQueryVariables = Types.Exact<{
  orchestratorId: Types.Scalars['String']['input'];
}>;


export type ReadVplcCreateOptionsQuery = { __typename: 'Query', vplcCreateOptions: { __typename: 'VplcCreateOptionsType', internetReachable: boolean, runtimeVersions: Array<{ __typename: 'RuntimeVersionType', version: string, downloaded: boolean, prerelease: boolean }>, hostInterfaces: Array<{ __typename: 'HostInterfaceType', name: string, ipAddress?: string, subnet?: string, gateway?: string }> } };

export type ReadOrchestratorInstallCommandQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadOrchestratorInstallCommandQuery = { __typename: 'Query', orchestratorInstallCommand: string };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const OpenPlcEditSessionFragmentDoc = new TypedDocumentString(`
    fragment OpenPlcEditSession on EditSessionType {
  __typename
  sessionId
  state
  expiresAt
  isLive
}
    `, {"fragmentName":"OpenPlcEditSession"});
export const OpenPlcStagedChangeFragmentDoc = new TypedDocumentString(`
    fragment OpenPlcStagedChange on StagedChangeType {
  __typename
  sessionId
  revision
  savedAt
  fileSize
  fileName
  warnings
}
    `, {"fragmentName":"OpenPlcStagedChange"});
export const OpenPlcProjectStatusFragmentDoc = new TypedDocumentString(`
    fragment OpenPlcProjectStatus on ProjectStatusType {
  __typename
  projectId
  locked
  session {
    __typename
    ...OpenPlcEditSession
  }
  stagedChange {
    __typename
    ...OpenPlcStagedChange
  }
}
    fragment OpenPlcEditSession on EditSessionType {
  __typename
  sessionId
  state
  expiresAt
  isLive
}
fragment OpenPlcStagedChange on StagedChangeType {
  __typename
  sessionId
  revision
  savedAt
  fileSize
  fileName
  warnings
}`, {"fragmentName":"OpenPlcProjectStatus"});
export const OpenPlcOrchestratorFragmentDoc = new TypedDocumentString(`
    fragment OpenPlcOrchestrator on OrchestratorType {
  __typename
  orchestratorId
  name
  status
  agentVersion
  createdAt
  registeredByUserId
}
    `, {"fragmentName":"OpenPlcOrchestrator"});
export const OpenPlcVplcFragmentDoc = new TypedDocumentString(`
    fragment OpenPlcVplc on VplcType {
  __typename
  vplcId
  orchestratorId
  name
  autonomyId
  recordState
  runtimeVersion
  provisioningState
  provisioningDetail
  lastSeenBuildingAt
  isRunning
  healthStatus
  containerStatus
  ipAddress
  createdByUserId
}
    `, {"fragmentName":"OpenPlcVplc"});
export const OpenPlcVplcCreateOptionsFragmentDoc = new TypedDocumentString(`
    fragment OpenPlcVplcCreateOptions on VplcCreateOptionsType {
  __typename
  runtimeVersions {
    __typename
    version
    downloaded
    prerelease
  }
  hostInterfaces {
    __typename
    name
    ipAddress
    subnet
    gateway
  }
  internetReachable
}
    `, {"fragmentName":"OpenPlcVplcCreateOptions"});
export const OpenEditSessionDocument = new TypedDocumentString(`
    mutation OpenEditSession($projectId: String!, $versionId: String) {
  __typename
  openEditSession(projectId: $projectId, input: {versionId: $versionId}) {
    __typename
    sessionId
    launchUrl
    expiresAt
    openedFrom
    warnings
  }
}
    `);
export const EndEditSessionDocument = new TypedDocumentString(`
    mutation EndEditSession($projectId: String!) {
  __typename
  endEditSession(projectId: $projectId) {
    __typename
    ...OpenPlcEditSession
  }
}
    fragment OpenPlcEditSession on EditSessionType {
  __typename
  sessionId
  state
  expiresAt
  isLive
}`);
export const AcceptStagedChangeDocument = new TypedDocumentString(`
    mutation AcceptStagedChange($projectId: String!, $commitMessage: String) {
  __typename
  acceptStagedChange(
    projectId: $projectId
    input: {commitMessage: $commitMessage}
  ) {
    __typename
    versionId
  }
}
    `);
export const DiscardStagedChangeDocument = new TypedDocumentString(`
    mutation DiscardStagedChange($projectId: String!) {
  __typename
  discardStagedChange(projectId: $projectId) {
    __typename
    ...OpenPlcStagedChange
  }
}
    fragment OpenPlcStagedChange on StagedChangeType {
  __typename
  sessionId
  revision
  savedAt
  fileSize
  fileName
  warnings
}`);
export const RegisterOrchestratorDocument = new TypedDocumentString(`
    mutation RegisterOrchestrator($orchestratorId: String!, $name: String!) {
  __typename
  createOrchestrator(input: {orchestratorId: $orchestratorId, name: $name}) {
    __typename
    ...OpenPlcOrchestrator
  }
}
    fragment OpenPlcOrchestrator on OrchestratorType {
  __typename
  orchestratorId
  name
  status
  agentVersion
  createdAt
  registeredByUserId
}`);
export const RenameOrchestratorDocument = new TypedDocumentString(`
    mutation RenameOrchestrator($orchestratorId: String!, $name: String!) {
  __typename
  renameOrchestrator(orchestratorId: $orchestratorId, name: $name) {
    __typename
    ...OpenPlcOrchestrator
  }
}
    fragment OpenPlcOrchestrator on OrchestratorType {
  __typename
  orchestratorId
  name
  status
  agentVersion
  createdAt
  registeredByUserId
}`);
export const OrchestratorCommandDocument = new TypedDocumentString(`
    mutation OrchestratorCommand($orchestratorId: String!, $command: LifecycleCommand!) {
  __typename
  orchestratorCommand(orchestratorId: $orchestratorId, command: $command) {
    __typename
    orchestratorId
    command
  }
}
    `);
export const DeleteOrchestratorDocument = new TypedDocumentString(`
    mutation DeleteOrchestrator($orchestratorId: String!) {
  __typename
  deleteOrchestrator(orchestratorId: $orchestratorId) {
    __typename
    orchestratorId
    deletedVplcIds
  }
}
    `);
export const CreateVplcDocument = new TypedDocumentString(`
    mutation CreateVplc($input: CreateVplcInput!) {
  __typename
  createVplc(input: $input) {
    __typename
    ...OpenPlcVplc
  }
}
    fragment OpenPlcVplc on VplcType {
  __typename
  vplcId
  orchestratorId
  name
  autonomyId
  recordState
  runtimeVersion
  provisioningState
  provisioningDetail
  lastSeenBuildingAt
  isRunning
  healthStatus
  containerStatus
  ipAddress
  createdByUserId
}`);
export const RenameVplcDocument = new TypedDocumentString(`
    mutation RenameVplc($vplcId: String!, $name: String!) {
  __typename
  renameVplc(vplcId: $vplcId, name: $name) {
    __typename
    ...OpenPlcVplc
  }
}
    fragment OpenPlcVplc on VplcType {
  __typename
  vplcId
  orchestratorId
  name
  autonomyId
  recordState
  runtimeVersion
  provisioningState
  provisioningDetail
  lastSeenBuildingAt
  isRunning
  healthStatus
  containerStatus
  ipAddress
  createdByUserId
}`);
export const VplcCommandDocument = new TypedDocumentString(`
    mutation VplcCommand($vplcId: String!, $command: LifecycleCommand!) {
  __typename
  vplcCommand(vplcId: $vplcId, command: $command) {
    __typename
    vplcId
    command
  }
}
    `);
export const DeleteVplcDocument = new TypedDocumentString(`
    mutation DeleteVplc($vplcId: String!) {
  __typename
  deleteVplc(vplcId: $vplcId) {
    __typename
    vplcId
  }
}
    `);
export const ReadOpenPlcProjectStatusDocument = new TypedDocumentString(`
    query ReadOpenPlcProjectStatus($projectId: String!) {
  __typename
  projectStatus(projectId: $projectId) {
    __typename
    ...OpenPlcProjectStatus
  }
}
    fragment OpenPlcEditSession on EditSessionType {
  __typename
  sessionId
  state
  expiresAt
  isLive
}
fragment OpenPlcStagedChange on StagedChangeType {
  __typename
  sessionId
  revision
  savedAt
  fileSize
  fileName
  warnings
}
fragment OpenPlcProjectStatus on ProjectStatusType {
  __typename
  projectId
  locked
  session {
    __typename
    ...OpenPlcEditSession
  }
  stagedChange {
    __typename
    ...OpenPlcStagedChange
  }
}`);
export const ReadOrchestratorsDocument = new TypedDocumentString(`
    query ReadOrchestrators {
  __typename
  orchestrators {
    __typename
    ...OpenPlcOrchestrator
  }
}
    fragment OpenPlcOrchestrator on OrchestratorType {
  __typename
  orchestratorId
  name
  status
  agentVersion
  createdAt
  registeredByUserId
}`);
export const ReadVplcsDocument = new TypedDocumentString(`
    query ReadVplcs($orchestratorId: String!) {
  __typename
  vplcs(orchestratorId: $orchestratorId) {
    __typename
    ...OpenPlcVplc
  }
}
    fragment OpenPlcVplc on VplcType {
  __typename
  vplcId
  orchestratorId
  name
  autonomyId
  recordState
  runtimeVersion
  provisioningState
  provisioningDetail
  lastSeenBuildingAt
  isRunning
  healthStatus
  containerStatus
  ipAddress
  createdByUserId
}`);
export const ReadVplcCreateOptionsDocument = new TypedDocumentString(`
    query ReadVplcCreateOptions($orchestratorId: String!) {
  __typename
  vplcCreateOptions(orchestratorId: $orchestratorId) {
    __typename
    ...OpenPlcVplcCreateOptions
  }
}
    fragment OpenPlcVplcCreateOptions on VplcCreateOptionsType {
  __typename
  runtimeVersions {
    __typename
    version
    downloaded
    prerelease
  }
  hostInterfaces {
    __typename
    name
    ipAddress
    subnet
    gateway
  }
  internetReachable
}`);
export const ReadOrchestratorInstallCommandDocument = new TypedDocumentString(`
    query ReadOrchestratorInstallCommand {
  __typename
  orchestratorInstallCommand
}
    `);

const injectedRtkApi = baseOpenplcApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    OpenEditSession: build.mutation<Types.OpenEditSessionMutation, Types.OpenEditSessionMutationVariables>({
      query: (variables) => ({ document: OpenEditSessionDocument as unknown as string, variables })
    }),
    EndEditSession: build.mutation<Types.EndEditSessionMutation, Types.EndEditSessionMutationVariables>({
      query: (variables) => ({ document: EndEditSessionDocument as unknown as string, variables })
    }),
    AcceptStagedChange: build.mutation<Types.AcceptStagedChangeMutation, Types.AcceptStagedChangeMutationVariables>({
      query: (variables) => ({ document: AcceptStagedChangeDocument as unknown as string, variables })
    }),
    DiscardStagedChange: build.mutation<Types.DiscardStagedChangeMutation, Types.DiscardStagedChangeMutationVariables>({
      query: (variables) => ({ document: DiscardStagedChangeDocument as unknown as string, variables })
    }),
    RegisterOrchestrator: build.mutation<Types.RegisterOrchestratorMutation, Types.RegisterOrchestratorMutationVariables>({
      query: (variables) => ({ document: RegisterOrchestratorDocument as unknown as string, variables })
    }),
    RenameOrchestrator: build.mutation<Types.RenameOrchestratorMutation, Types.RenameOrchestratorMutationVariables>({
      query: (variables) => ({ document: RenameOrchestratorDocument as unknown as string, variables })
    }),
    OrchestratorCommand: build.mutation<Types.OrchestratorCommandMutation, Types.OrchestratorCommandMutationVariables>({
      query: (variables) => ({ document: OrchestratorCommandDocument as unknown as string, variables })
    }),
    DeleteOrchestrator: build.mutation<Types.DeleteOrchestratorMutation, Types.DeleteOrchestratorMutationVariables>({
      query: (variables) => ({ document: DeleteOrchestratorDocument as unknown as string, variables })
    }),
    CreateVplc: build.mutation<Types.CreateVplcMutation, Types.CreateVplcMutationVariables>({
      query: (variables) => ({ document: CreateVplcDocument as unknown as string, variables })
    }),
    RenameVplc: build.mutation<Types.RenameVplcMutation, Types.RenameVplcMutationVariables>({
      query: (variables) => ({ document: RenameVplcDocument as unknown as string, variables })
    }),
    VplcCommand: build.mutation<Types.VplcCommandMutation, Types.VplcCommandMutationVariables>({
      query: (variables) => ({ document: VplcCommandDocument as unknown as string, variables })
    }),
    DeleteVplc: build.mutation<Types.DeleteVplcMutation, Types.DeleteVplcMutationVariables>({
      query: (variables) => ({ document: DeleteVplcDocument as unknown as string, variables })
    }),
    ReadOpenPlcProjectStatus: build.query<Types.ReadOpenPlcProjectStatusQuery, Types.ReadOpenPlcProjectStatusQueryVariables>({
      query: (variables) => ({ document: ReadOpenPlcProjectStatusDocument as unknown as string, variables })
    }),
    ReadOrchestrators: build.query<Types.ReadOrchestratorsQuery, Types.ReadOrchestratorsQueryVariables | void>({
      query: (variables) => ({ document: ReadOrchestratorsDocument as unknown as string, variables })
    }),
    ReadVplcs: build.query<Types.ReadVplcsQuery, Types.ReadVplcsQueryVariables>({
      query: (variables) => ({ document: ReadVplcsDocument as unknown as string, variables })
    }),
    ReadVplcCreateOptions: build.query<Types.ReadVplcCreateOptionsQuery, Types.ReadVplcCreateOptionsQueryVariables>({
      query: (variables) => ({ document: ReadVplcCreateOptionsDocument as unknown as string, variables })
    }),
    ReadOrchestratorInstallCommand: build.query<Types.ReadOrchestratorInstallCommandQuery, Types.ReadOrchestratorInstallCommandQueryVariables | void>({
      query: (variables) => ({ document: ReadOrchestratorInstallCommandDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useOpenEditSessionMutation, useEndEditSessionMutation, useAcceptStagedChangeMutation, useDiscardStagedChangeMutation, useRegisterOrchestratorMutation, useRenameOrchestratorMutation, useOrchestratorCommandMutation, useDeleteOrchestratorMutation, useCreateVplcMutation, useRenameVplcMutation, useVplcCommandMutation, useDeleteVplcMutation, useReadOpenPlcProjectStatusQuery, useLazyReadOpenPlcProjectStatusQuery, useReadOrchestratorsQuery, useLazyReadOrchestratorsQuery, useReadVplcsQuery, useLazyReadVplcsQuery, useReadVplcCreateOptionsQuery, useLazyReadVplcCreateOptionsQuery, useReadOrchestratorInstallCommandQuery, useLazyReadOrchestratorInstallCommandQuery } = injectedRtkApi;

